import { createGlobalState } from '@vueuse/core'
import { useAuthStore } from '@/stores'
import { computed } from 'vue'

export const useSystem = createGlobalState(() => {
  const sysEnv = `${(window as any).configuration.env || ''}`.toLowerCase()
  const authStore = useAuthStore()

  // Dev / QA ou em contratos seletos em PROD
  const isBetaEnv = computed(() =>
    ['homolog', 'integration', 'development'].includes(sysEnv) ||
    ['d23d42e7-9e47-45b5-9db1-066237a2a63e', 'fafca64f-a53b-478e-90b2-98f0e8e95cac'].includes(authStore.getActiveTentant)
  )

  return {
    sysEnv,
    isBetaEnv,
    isProd: sysEnv === 'production'
  }
})